// returnStore.js
const store = {};

export const setPending = (key, value) => {
  store[key] = value;
};

export const consumePending = (key) => {
  const value = store[key];
  delete store[key]; // clear after consumption
  return value;
};



//sender
// import { setPending } from './returnStore';

// setPending("contact", { name: "John", phone: "12345" });
// setPending("cityApproval", { id: 21, result: "approved" });

// navigate(-1);


//receiver
// import { consumePending } from './returnStore';

// useEffect(() => {
//   const contact = consumePending("contact");
//   if (contact) {
//     console.log("New contact:", contact);
//   }

//   const cityApproval = consumePending("cityApproval");
//   if (cityApproval) {
//     console.log("City result:", cityApproval.result);
//   }
// }, []);
